import React, { useState } from "react";
import { jsPDF } from "jspdf";

const WardManagement = () => {
  const [wardName, setWardName] = useState("");
  const [search, setSearch] = useState("");
  const [wards, setWards] = useState([]);

  const addWard = () => {
    if (!wardName.trim()) {
      alert("कृपया वॉर्डचे नाव भरा");
      return;
    }
    setWards([...wards, { id: Date.now(), name: wardName }]);
    setWardName("");
  };

  const deleteWard = (id) => {
    setWards(wards.filter((w) => w.id !== id));
  };

  const generatePDF = async (specificId = null) => {
    try {
      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      
      pdf.setFillColor(79, 131, 163);
      pdf.rect(0, 0, pageWidth, 15, "F");
      pdf.setTextColor(255, 255, 255);
      pdf.setFontSize(16);
      pdf.text("वॉर्ड व्यवस्थापन", pageWidth / 2, 10, { align: "center" });
      
      pdf.setTextColor(0, 0, 0);
      pdf.setFontSize(10);
      pdf.text(`तारीख: ${new Date().toLocaleDateString("en-GB")}`, 15, 25);
      
      const exportData = specificId 
        ? wards.filter(item => item.id === specificId)
        : wards;
      
      const tableData = exportData.map((item, index) => [
        index + 1,
        item.name
      ]);
      
      pdf.autoTable({
        head: [["अ.क्र.", "वॉर्डचे नाव"]],
        body: tableData,
        startY: 32,
        theme: "grid",
        headStyles: {
          fillColor: [241, 244, 255],
          textColor: [44, 62, 80],
          fontStyle: "bold",
          fontSize: 11
        },
        bodyStyles: {
          textColor: [73, 80, 87],
          fontSize: 10
        },
        alternateRowStyles: {
          fillColor: [248, 249, 250]
        }
      });
      
      const pageCount = pdf.internal.pages.length - 1;
      for (let i = 1; i <= pageCount; i++) {
        pdf.setPage(i);
        pdf.setFontSize(9);
        pdf.setTextColor(128, 128, 128);
        pdf.text(`पृष्ठ ${i} / ${pageCount}`, pageWidth / 2, pdf.internal.pageSize.getHeight() - 10, { align: "center" });
      }
      
      const fileName = specificId ? `वॉर्ड-${specificId}.pdf` : `वॉर्ड-यादी.pdf`;
      pdf.save(fileName);
    } catch (error) {
      alert("PDF तयार करताना त्रुटी: " + error.message);
    }
  };

  const filteredWards = wards.filter((w) =>
    w.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div>
      {/* Add Ward */}
      <div className="card-box">
        <div className="title">नवीन वॉर्डची नोंदणी</div>

        <div className="row align-items-end">
          <div className="col-md-4">
            <label className="form-label fw-semibold">
              वॉर्डचे नाव / क्रमांक
            </label>
            <input
              type="text"
              className="form-control"
              value={wardName}
              onChange={(e) => setWardName(e.target.value)}
              placeholder="उदा. 1, 5, 66"
            />
          </div>

          <div className="col-md-3 mt-3 mt-md-0">
            <button className="add-btn w-100" onClick={addWard}>
              वॉर्ड जोडा
            </button>
          </div>
        </div>
      </div>

      {/* Search + Count */}
      <div className="card-box">
        <div className="row align-items-end">
          <div className="col-md-4">
            <label className="form-label fw-semibold">वॉर्ड शोधा</label>
            <input
              type="text"
              className="form-control"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="वॉर्ड नाव टाका"
            />
          </div>

          <div className="col-md-3">
            <div className="count-box">
              एकूण वॉर्ड <br />
              <span>{filteredWards.length}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Ward Table */}
      <div className="card-box">
        <div className="table-header">
          <h3>वॉर्ड यादी</h3>
          <div className="pdf-buttons">
            <button className="btn-pdf-all" onClick={() => generatePDF()}>
              📄 सर्व PDF
            </button>
          </div>
        </div>
        <table className="table table-bordered m-0">
          <thead>
            <tr>
              <th>वॉर्डचे नाव</th>
              <th style={{ width: "130px" }}>क्रिया</th>
            </tr>
          </thead>
          <tbody>
            {filteredWards.length === 0 ? (
              <tr>
                <td colSpan="2" className="text-center empty">
                  माहिती सापडली नाही
                </td>
              </tr>
            ) : (
              filteredWards.map((ward) => (
                <tr key={ward.id}>
                  <td>{ward.name}</td>
                  <td>
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => deleteWard(ward.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default WardManagement;
